import { ResponseDeleteGroupFolder } from '@/modules/drive/domain/models/DeleteFolderGroup'

import { axios, Response } from '../index'

const deleteShareFolder = (
  folderId: string,
  patientId: string,
  profileId: string,
  permissionName: string
): Response<ResponseDeleteGroupFolder> => {
  return axios.delete(
    `/v1/folders/${folderId}/patients/${patientId}/personas/${profileId}/permissions/${permissionName}`
  )
}

export default deleteShareFolder
